export default function DashboardStore(){
  return (<div>This will be the store</div>);
}